// extracted by css-extract-rspack-plugin
export default {"ItemTitle":"P4r9I","ItemIcon":"OPobu","ItemList":"zY5XD","Label":"yeP0F","ToggleItem":"GVojn"};